import React, { useEffect, useState } from "react";
import Styles from "./userCard.module.css";
import { Card } from "@mui/material";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import WhatsApp from "../../Components/Icons/WhatsApp";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { WhatsappShareButton } from "react-share";
import { WhatsappIcon } from "react-share";
import ThreeDotsMenu from "../ThreeDotsMenu";
//TimeAgo
import ReactTimeAgo from "react-time-ago";
// import TimeAgo from "javascript-time-ago";
// import en from "javascript-time-ago/locale/en.json";

import { useSelector } from "react-redux";
//Modals
import TimeLineAndNotes from "../../Modals/TimeLineAndNotes/TimeLineAndNotes";
import AddPreference from "../../Modals/AddPreference/AddPreference";
import CustomInput from "../CustomInput";
import { getAllotedData } from "../../Services/LeadService";
import {
  getBasicBrokerageForAllotments,
  getAgreementDatesForAllotments,
} from "../../Services/BrokerageService";
import { Box, Divider } from "@material-ui/core";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CallIcon from "@mui/icons-material/Call";
// Basic Brokerage: allotments before this date keep the old hard-coded % logic;
// from this date onward, Basic Brokerage is derived from the CP Benefit Plan (BrokerageService).
const BASIC_BROKERAGE_BENEFIT_PLAN_START = new Date("2026-04-01");
function LeadCard({ data, actionStyles, returnButtonResp }) {
  // TimeAgo.setDefaultLocale(en.locale);
  // TimeAgo.addLocale(en);
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
 
  const [style, setStyle] = useState(null);
  // Basic Brokerage per allotment, derived from the CP Benefit Plan (see BrokerageService).
  // Keyed by allotmentPaymentId → { amount, source, label }.
  const [brokerageMap, setBrokerageMap] = useState({});
  // Real Agreement Date per allotment (AgreementForm.agreementStatus.agreement_date), used to
  // decide the Benefit Plan cutover — distinct from AllotmentPayment.created_at ("Allotment Date").
  const [agreementDateMap, setAgreementDateMap] = useState({});
  const WhatsAppMessage = `Hello Mr.${data.personName}%0a %0aGreetings from Vilas Javdekar Developers%0a %0aYou have been successfully registered with us through one of our esteemed Channel Partners.We will always be at your service to help you book your Dream Home with VJ. Looking forward to welcome you to our VJ Parivaar soon!Our Official Website is :www.javdekars.com.-Team VJ.`;
  const [dropdownList, setDropdownList] = useState([
    "Add preference",
    "Timeline and Notes",
  ]);
  const [timeLineAndNotesModal, setTimeLineAndNotesModal] = useState(false);
  const [addPreferenceModal, setAddPreferenceModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [copyLeadObj, setCopyLeadObj] = useState(data);
  useEffect(() => {
    defineColorSchema();
    return () => {};
  }, []);
  function defineColorSchema() {
    let obj = {};
    if (data.status === "Allotment Done") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data.status === "Claimed") {
      obj.chipColor = "#F79009";
      obj.chipBackgroundColor = "#FFFAEB";
    } else if (data.status === "Unit On Hold") {
      obj.chipColor = "#FF4405";
      obj.chipBackgroundColor = "#FFE6D5";
    } else if (data.status === "Allotment Partial Payment Done") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
    } else if (data.status === "Token Payment Pending") {
      obj.chipColor = "#C11574";
      obj.chipBackgroundColor = "#FDF2FA";
    } else if (data.status === "Token Partial Payment Done") {
      obj.chipColor = "#BC1B06";
      obj.chipBackgroundColor = "#FFF4ED";
    } else if (data.status === "Token Payment Complete") {
      obj.chipColor = "#3538CD";
      obj.chipBackgroundColor = "#EEF4FF";
    } else if (data.status === "Site Visit Done") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data.status === "Site Visit Scheduled") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
    } else if (data.status === "Closed") {
      obj.chipColor = "#027A48";
      obj.chipBackgroundColor = "#ECFDF3";
    } else if (data.status === "Checkpoint One Cleared") {
      obj.chipColor = "#6941C6";
      obj.chipBackgroundColor = "#F4EBFF";
    } else if (data.status === "Checkpoint Two Cleared") {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
    } else if (
      data.status === "Allotment Payment Complete" ||
      data.status === "Agreement Done" ||
      data.status === "Change Unit Requested" ||
      data.status === "Cancellation Confirmation Pending" ||
      data.status === "Cancel Unit Done" ||
      data.status === "Cancel Unit Not Done" ||
      data.status === "Change Unit Confirmation Rejected" ||
      data.status === "Change Unit Confirmed" ||
      data.status === "Change Unit Rejected" ||
      data.status === "Cancel Unit Requested" ||
      data.status === "PreSelect Payment Pending" ||
      data.status === "PreSelect Unit on Hold" ||
      data.status === "Preselect not confirmed"||
      data.status === "PreSelect Partial Payment Done"||
      data.status === "PreSelect Confirmation Pending"    ) {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
      }
      else if (data.status === "Unit on Hold") {
        obj.chipColor = "#C01048";
        obj.chipBackgroundColor = "#FFF1F3";
      }
      else if (data.status === "Allotment Payment Pending") {
        obj.chipColor = "#C01048";
        obj.chipBackgroundColor = "#FFF1F3";
      }else if (
        data.status === "Allotment Partial Payment Done" ||
        data.status === "Preselect payment not done"
      ) {
        obj.chipColor = "#C01048";
        obj.chipBackgroundColor = "#FFF1F3";
      }
    else {
      obj.chipBackgroundColor = " #ececec";
      // obj.chipColor = "#667085";
    }

    setStyle(obj);
  }
  function returnButtonRespose(value) {
    console.log(value);
    if (value) {
      returnButtonResp(true);
    }
  }

  function getLeadAlotedProject() {
    getAllotedData(copyLeadObj.leadId)
      .then((resp) => {
        console.log(resp);
        resp.data = resp.data.map((each) => ({
          ...each,
          WhatsAppMessage:
            each.status === "Payment Complete" && each.kycFormFilled
              ? `Hello Mr.${
                  copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${
                  each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                }.%0a Your Allotment payment status:${
                  each.status
                }.%0aCustomer Portal link:${
                  process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0a %0aRegards,Team VJ`
              : each.status === "Payment Complete" && !each.kycFormFilled
              ? `Hello Mr.${
                  copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${
                  each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                }.%0aYour Allotment payment status:${
                  each.status
                }.%0aPlease complete your kyc through Customer Portal link:${
                  process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0a %0aRegards,Team VJ`
              : each.status === "Partial Payment Done" && !each.kycFormFilled
              ? `Hello Mr.${
                  copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${
                  each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                }.%0aYour Allotment payment status:${
                  each.status
                }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed.${
                  process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0a %0aRegards,Team VJ`
              : each.status === "Partial Payment Done" && each.kycFormFilled
              ? `Hello Mr.${
                  copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${
                  copyLeadObj.leadstatus
                }.%0aYour Allotment payment status:${
                  each.status
                }.%0aYour selection ${
                  each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                }.%0aPlease complete your payment through:${
                  process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0a %0aRegards,Team VJ`
              : each.status === "Payment Pending"
              ? `Hello Mr.${
                  copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${
                  copyLeadObj.leadstatus
                }.%0aYour Allotment payment status:${
                  each.status
                }.%0aYour selection ${
                  each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                }%0aPlease Confirm your booking by paying through the link below:%0a${
                  process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`
              : `Hello Mr.${
                  copyLeadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${
                  copyLeadObj.leadstatus
                }.%0aYour Allotment payment status:${
                  each.status
                }.Your selection ${
                  each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                }%0aPlease Confirm your booking by paying through the link below:%0a:${
                  process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`,
        }));
        let allotmentData = resp.data;

        setCopyLeadObj((pre) => {
          return { ...pre, allotmentData };
        });
        console.log(copyLeadObj);

        // Basic Brokerage is CP-only; from 1 Apr 2026 onward (by Agreement Date), derive it
        // from the Benefit Plan instead of the old hard-coded %.
        if (loggedInUser?.type === "CP") {
          const allotmentPaymentIds = (allotmentData || [])
            .map((a) => a?.allotmentPaymentId)
            .filter(Boolean);

          getAgreementDatesForAllotments(allotmentPaymentIds)
            .then((dateMap) => {
              setAgreementDateMap(dateMap || {});

              const benefitPlanAllotments = (allotmentData || []).filter(
                (a) => {
                  const cutoffDate =
                    dateMap?.[a?.allotmentPaymentId] || a?.created_at;
                  return (
                    new Date(cutoffDate) >= BASIC_BROKERAGE_BENEFIT_PLAN_START
                  );
                }
              );
              if (benefitPlanAllotments.length) {
                getBasicBrokerageForAllotments(benefitPlanAllotments)
                  .then((map) => setBrokerageMap(map || {}))
                  .catch((e) =>
                    console.error("Basic Brokerage calculation failed", e)
                  );
              }
            })
            .catch((e) =>
              console.error("Agreement date lookup failed", e)
            );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  // Pre-1-Apr-2026 Basic Brokerage: hard-coded 2%/3% by allotment date (superseded by
  // BrokerageService's Benefit Plan lookup for allotments on/after BASIC_BROKERAGE_BENEFIT_PLAN_START).
  function toCalculateValueFromPercent(percentage, bsp) {
    var numVal1 = Number(bsp);
    var numVal2 = Number(percentage) / 100;

    var totalValue = numVal1 * numVal2;

    return Math.ceil(totalValue);
  }
  const isLost = String(data?.status || "").trim().toLowerCase() === "lost";
  return (
    <Card className={`${Styles.userCard}${isLost ? " " + Styles.lostCard : ""}`}>
      <div className={Styles.head}>
        <div className={Styles.nm} style={{ width: "auto" }}>
          <div className={Styles.pref}>{data.personName[0]}</div>
          <div className={Styles.title}>
            <div className={Styles.name}>
              {data.personName}
              <div className={Styles.fosId}>
                {"VJ" +
                  data?.leadDisplayId.replace(
                    data?.leadDisplayId.substring(8, 12),
                    "-" + data.leadDisplayId.substring(8, 12)
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.headerDiv2}>
          <div className={Styles.status}>
            <LeadStatusChip
              style={{
                color: style?.chipColor,
                backgroundColor: style?.chipBackgroundColor,
              }}
              label={data.status}
              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
            />
          </div>
          {/* Site-visit verification badge (from SiteVisits.is_verified via the leadsfilter RPC). */}
          <div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.6rem",
                padding: "0.3rem 1.2rem",
                borderRadius: "1.6rem",
                fontSize: "1.3rem",
                fontFamily: "Inter-Medium",
                whiteSpace: "nowrap",
                backgroundColor: data?.isverified ? "#ECFDF3" : "#FFFAEB",
                color: data?.isverified ? "#067647" : "#B54708",
                border: `1px solid ${data?.isverified ? "#ABEFC6" : "#FEDF89"}`,
              }}
            >
              <span
                style={{
                  width: "0.7rem",
                  height: "0.7rem",
                  borderRadius: "50%",
                  backgroundColor: data?.isverified ? "#17B26A" : "#F79009",
                }}
              />
              {data?.isverified ? "Verified" : "Unverified"}
            </div>
          </div>
          <div>
            <ReactTimeAgo
              style={{ fontSize: "1.2rem" }}
              date={data?.statuschangeddate ?data?.statuschangeddate : data?.last_updated_at}
              locale="en-US"
            />
          </div>
          <div>
            <ThreeDotsMenu
              list={dropdownList}
              selectedValue={(e) => {
                console.log(e);
                if (e === "Timeline and Notes") {
                  setTimeLineAndNotesModal(true);
                } else if (e === "Add preference") {
                  setAddPreferenceModal(true);
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className={Styles.body}>
        <div className={Styles.leadContact}>
          <div className={Styles.lead_phone}>+{data.phoneNumber}</div> |
          <div className={Styles.email}>{data.email}</div>
        </div>
        {/* </div> */}
        {/* {loggedInUser?.cpType === "Entity" && ( */}
          <div className={Styles.lead}>FOS : {data.FOS==='-'?'NA':data.FOS}</div>
        {/* )} */}
{data?.status!=='Unclaimed'&&(
        <div>
          <span className={Styles.label}>VJ SM:</span>
          <span className={Styles.labelValue}>
            {" "}
            {data?.salesname === null ? "-" : data?.salesname}
          </span>
        </div>

)}

        <div className={Styles.wrapperWhatsAppShare} styles={actionStyles}>
          <a
            href={`https://wa.me/${data.phoneNumber}/?text=${WhatsAppMessage}`}
            data-action="share/whatsapp/share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappIcon size={32} round={true} />
          </a>
        </div>
      </div>
      <div className={Styles.wrapperCreatedAt}>
        <div>
          <CalendarTodayOutlinedIcon
            style={{ color: "#1D2939", verticalAlign: "middle" }}
          />
        </div>
        <div className={Styles.fosId}>Created At:</div>
        <div className={Styles.fosId}>
          {new Date(data.statuschangeddate).toDateString()},{" "}
          {new Date(data.statuschangeddate).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </div>

      
      {showDetails &&
            copyLeadObj?.allotmentData?.map((eachAllotment) => {
              const projectName = eachAllotment?.unitId?.projectId?.projectName
                ? eachAllotment?.unitId?.projectId?.projectName
                : eachAllotment?.inventoryMergedId?.projectId?.projectName;
              // Moved verbatim from the old "Unit" field, which now sits beside
              // the project name. Merged bookings list both units.
              const unitName =
                eachAllotment?.unitId !== null
                  ? eachAllotment?.unitId?.wingId?.wingName +
                    "-" +
                    eachAllotment?.unitId?.unitNo
                  : eachAllotment?.inventoryMergedId?.unit1Id?.wingId?.wingName +
                    "-" +
                    eachAllotment?.inventoryMergedId?.unit1No +
                    "," +
                    eachAllotment?.inventoryMergedId?.unit1Id?.wingId?.wingName +
                    "-" +
                    eachAllotment?.inventoryMergedId?.unit2No;
              return (
                <div style={{ marginTop: "2rem" }}>
                  <Divider
                    sx={{
                      width: "100%",
                      borderColor: "#EAECF0",
                      marginBottom: "1.2rem",
                      marginTop:'1rem'
                    }}
                  />
                  <div className={Styles.projectDiv}>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                      }}
                    >
                      <div className={Styles.projectNameLabel}>
                        <p>Project Name</p>
                      </div>
                      <div className={Styles.label}>
                        <p>:</p>
                      </div>
                      <div className={Styles.projectNameValue}>
                        <p>
                          {projectName}
                          {unitName ? " | Unit : " + unitName : ""}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <div>
                          {(eachAllotment.status === "Partial Payment Done" ||
                            eachAllotment.status === "Payment Complete") &&
                            !eachAllotment.kycFormFilled && (
                              <LeadStatusChip
                                label={"Kyc pending"}
                                icon={
                                  <Dot width={"0.5rem"} height={"0.5rem"} />
                                }
                                style={{
                                  color: "#0E7090",
                                  backgroundColor: "#ECFDFF",
                                }}
                              ></LeadStatusChip>
                            )}
                          {eachAllotment.kycFormFilled && (
                            <LeadStatusChip
                              label={"Kyc Done"}
                              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                              style={{
                                color: "#0E7090",
                                backgroundColor: "#ECFDFF",
                              }}
                            ></LeadStatusChip>
                          )}
                        </div>
                        <div>
                          <LeadStatusChip
                            style={
                              eachAllotment?.status === "pending"
                                ? {
                                    color: "#B54708",
                                    backgroundColor: "#FFFAEB",
                                  }
                                : eachAllotment?.status === "Payment Complete"
                                ? {
                                    color: "#027A48",
                                    backgroundColor: "#ECFDF3",
                                  }
                                : {
                                    color: "#B54708",
                                    backgroundColor: "#FFF4ED",
                                  }
                            }
                            label={eachAllotment?.status}
                            icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          />
                        </div>
                      </div>
                   
                    </div>
                  </div>
                  <div className={Styles.projectDetails}>
                    <div style={{ marginTop: "1rem", width: "20%" }} className={Styles.allotmentEachBlock}>
                      <p>Allotment Date</p>
                      <CustomInput
                        // value={new Date(
                        //   eachAllotment?.last_updated_at
                        // ).toLocaleDateString()}
                        value={
                          new Date(eachAllotment?.created_at).toDateString()
                          // new Date( eachAllotment?.last_updated_at).toLocaleTimeString([], {
                          //   hour: "2-digit",
                          //   minute: "2-digit",
                          //  } )
                        }
                        disabled={true}
                      />
                    </div>
                    <div style={{ marginTop: "1rem", width: "15%" }} className={Styles.allotmentEachBlock}>
                      <p>Paid Amount</p>
                      {eachAllotment?.paidAmount ? (
                        <CustomInput
                          value={
                            "₹" + numberWithCommas(eachAllotment?.paidAmount)
                          }
                          disabled={true}
                        />
                      ) : (
                        <CustomInput
                          value={"₹" + eachAllotment?.paidAmount}
                          disabled={true}
                        />
                      )}
                    </div>
                    {/* Agreement Value = this allotment's unitCost->bsp, so a
                        lead with several allotments shows the right value
                        against each one. */}
                    <div style={{ marginTop: "1rem", width: "15%" }} className={Styles.allotmentEachBlock}>
                      <p>Agreement Value</p>
                      <CustomInput
                        value={
                          eachAllotment?.unitCost?.bsp
                            ? "₹" +
                              numberWithCommas(eachAllotment?.unitCost?.bsp)
                            : "-"
                        }
                        disabled={true}
                      />
                    </div>
                    <div style={{ marginTop: "1rem",width: "15%" }} className={Styles.allotmentEachBlock}>
                      <p>Total Cost</p>
                      {eachAllotment?.unitCost?.total ? (
                        <CustomInput
                          value={
                            "₹" +
                            numberWithCommas(eachAllotment?.unitCost?.total)
                          }
                          disabled={true}
                        />
                      ) : (
                        <CustomInput
                          value={"₹" + eachAllotment?.unitCost?.total}
                          disabled={true}
                        />
                      )}
                    </div>
                    {
                      loggedInUser?.type === "CP" &&
                      (() => {
                        // Gate on real Agreement Date; fall back to Allotment Date (created_at)
                        // for allotments that haven't reached agreement yet.
                        const cutoffDate =
                          agreementDateMap[eachAllotment?.allotmentPaymentId] ||
                          eachAllotment?.created_at;
                        const useBenefitPlan =
                          new Date(cutoffDate) >=
                          BASIC_BROKERAGE_BENEFIT_PLAN_START;

                        // Before 1 Apr 2026 (by Agreement Date): old hard-coded 2%/3%-by-date logic.
                        if (!useBenefitPlan) {
                          return (
                            <div
                              style={{ marginTop: "1rem", width: "15%" }}
                              className={Styles.allotmentEachBlock}
                            >
                              <p>Basic Brokerage</p>
                              {eachAllotment?.unitCost?.bsp && (
                                <CustomInput
                                  value={
                                    "₹" +
                                    numberWithCommas(
                                      toCalculateValueFromPercent(
                                        new Date(eachAllotment?.created_at) >=
                                          new Date("2025-04-01")
                                          ? 3
                                          : 2,
                                        eachAllotment?.unitCost?.bsp
                                      )
                                    )
                                  }
                                  disabled={true}
                                />
                              )}
                            </div>
                          );
                        }

                        // On/after 1 Apr 2026: Basic Brokerage as per the CP Benefit Plan (see BrokerageService).
                        const brokerage =
                          brokerageMap[eachAllotment?.allotmentPaymentId];
                        return (
                          <div
                            style={{ marginTop: "1rem", width: "15%" }}
                            className={Styles.allotmentEachBlock}
                          >
                            <p>{brokerage?.label || "Basic Brokerage"}</p>
                            {brokerage && brokerage.amount != null ? (
                              <CustomInput
                                value={"₹" + numberWithCommas(brokerage.amount)}
                                disabled={true}
                              />
                            ) : (
                              <CustomInput value={"-"} disabled={true} />
                            )}
                          </div>
                        );
                      })()
                    }
                   
                    <div
                      style={{ display: "flex", gap: "2rem" }}
                      // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
                    >
                      <a
                        href={`https://wa.me/${copyLeadObj.leadcontactnumber}/?text=${eachAllotment.WhatsAppMessage}`}
                        data-action="share/whatsapp/share"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsappIcon size={32} round={true} />
                      </a>
                      {/* <a
                        href={`tel:+${copyLeadObj.leadcontactnumber}`}
                        data-action="share/whatsapp/share"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CallIcon style={{ width: "4rem", height: '4rem' }} size={32} round={true} />
                      </a> */}
                    </div>
                  </div>
                  <div
                    style={{ width: "100%", height: "100%", marginTop: "2rem" }}
                  ></div>
                </div>
              );
            })}
   <div className={Styles.footer}>
          {
            //**In tabValue===All we need to show on status
            (copyLeadObj.status === "Token Payment Pending" ||
              copyLeadObj.status === "Token Partial Payment Done" ||
              copyLeadObj.status === "Token Payment Complete" ||
              copyLeadObj.status === "Preselect payment not done" ||
              copyLeadObj.status === "Token Refund Requested" ||
              copyLeadObj.status === "Token Refunded" ||
              copyLeadObj.status === "Token Refund Request Rejected" ||
              copyLeadObj.status === "Token Payment Not Done" ||
              copyLeadObj.status === "Allotment Partial Payment Done" ||
              copyLeadObj.status === "Allotment Refunded" ||
              copyLeadObj.status === "Allotment Payment Complete" ||
              copyLeadObj.status.includes(
                "Cancellation Confirmation Pending"
              ) ||
              copyLeadObj.status === "Cancellation Done" ||
              copyLeadObj.status === "Cancellation Not Done" ||
              copyLeadObj.status === "Change Unit Confirmation Pending" ||
              copyLeadObj.status === "Allotment Payment Pending" ||
              copyLeadObj.status === "Payment Pending" ||
              copyLeadObj.status === "Unit On Hold" ||
              copyLeadObj.status === "PreSelect Payment Pending" ||
              copyLeadObj.status === "Preselect not confirmed" ||
              copyLeadObj.status === "PreSelect Unit On Hold" ||
              copyLeadObj.status === "PreSelect Confirmation Pending" ||
              copyLeadObj.status === "Unit Change Requested" ||
              copyLeadObj.status === "PreSelect Price Confirmation Pending" ||
              copyLeadObj.status === "PreSelect Partial Payment Done" ||
              copyLeadObj.status === "Checkpoint One Cleared" ||
              copyLeadObj.status === "Checkpoint Two Cleared" ||
              copyLeadObj.status === "Change Unit Requested" ||
              copyLeadObj.status === "Change Unit Confirmation Pending" ||
              copyLeadObj.status === "Change Unit Confirmation Rejected" ||
              copyLeadObj.status === "Change Unit Confirmed" ||
              copyLeadObj.status === "Change Unit Rejected" ||
              copyLeadObj.status === "Site Visit Done" ||
              copyLeadObj.status === "Agreement Done" ||
              copyLeadObj.status === "Allotment Done") && (
              <div>
                <Box>
                  {!showDetails ? (
                    <Button
                      iconPosition={"right"}
                      padding={"0.5rem"}
                      clicked={() => {
                        setShowDetails(true);
                        // if (tabValue === "Token" || tabValue === "Token" || tabValue === "Allotment" || tabValue === "All") {
                        getLeadAlotedProject();
                        // }
                      }}
                      btnName={"More Details"}
                      style={{
                        color: "#1570EF",
                        borderRadius: "2.4rem",
                        backgroundColor: "#EFF8FF",
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        border: "1px solid #EFF8FF",
                      }}
                      btnIcon={
                        <KeyboardArrowDownIcon
                          style={{
                            color: "#1570EF",
                            width: "3rem",
                            height: "3rem",
                          }}
                        />
                      }
                    />
                  ) : (
                    <Button
                      iconPosition={"right"}
                      padding={"0.5rem"}
                      clicked={() => setShowDetails(false)}
                      btnName={"Hide Details"}
                      style={{
                        color: "#1570EF",
                        borderRadius: "2.4rem",
                        backgroundColor: "#EFF8FF",
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        border: "1px solid #EFF8FF",
                      }}
                      btnIcon={
                        <KeyboardArrowUpIcon
                          style={{
                            color: "#1570EF",
                            width: "3rem",
                            height: "3rem",
                          }}
                        />
                      }
                    />
                  )}
                </Box>
              </div>
            )
          }
          {(copyLeadObj.status === "Unclaimed" ||
            copyLeadObj.status === "Claimed" ||
            copyLeadObj.status === "Site Visit Scheduled" ||
            copyLeadObj.status === "Site Visit Done") && (
            <div
              style={{
                display: "flex",
                gap: "2rem",
                alignItems:'center'
              }}
              // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
            >
              <a
                href={`https://wa.me/${copyLeadObj.leadcontactnumber}/?text=${WhatsAppMessage}`}
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsappIcon size={32} round={true} />
              </a>
              <a
                href={`tel:+${copyLeadObj.leadcontactnumber}`}
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* <CallIcon
                  style={{ width: "3rem", height: "3rem" }}
                  round={true}
                /> */}
              </a>
            </div>
          )}

      
        </div>
      {addPreferenceModal && (
        <AddPreference
          open={addPreferenceModal}
          handleClose={() => {
            setAddPreferenceModal(false);
          }}
          data={data}
          returnRes={returnButtonRespose}
        />
      )}
      {timeLineAndNotesModal && (
        <TimeLineAndNotes
          open={timeLineAndNotesModal}
          handleClose={() => {
            setTimeLineAndNotesModal(false);
          }}
          data={data}
        />
      )}
    </Card>
  );
}
export default LeadCard;
